<template>
    <SwapMenu2 :swapid="swapid" title="Command Control" margin="1">
      <template v-slot:menu>
      <li> <a class="dropdown-item" @click="refresh()"> Refresh </a> </li>
      </template>
    </SwapMenu2>
    <div class="container divstyle">
        <div style='padding:10px'>
           <input type="file" @change="handleFileUpload( $event )"/>
           <button v-on:click="submitFile()">Upload</button>
        </div>

        <table class="table table-bordered table-striped font-custom">
            <thead class="headline">
                <tr class="tralign">
                    <th class=thx>FileName</th>
                    <th class=thx>Type</th>
                    <th class=thx>Size</th>
                    <th class=thx>DateTime</th>
                </tr>
            </thead>
            <tbody>
              <template v-for="data in filterlist" :key="data[0]"> 
              <tr v-show="selected.includes(data[1])" 
                  @click="doaction($event, data[0])">
                    <td class="colpad">{{data[0]}}</td>
                    <td class="colpad">{{data[1]}}</td>
                    <td class="colpad">{{data[2]}}</td>
                    <td class="colpad">{{data[3]}}</td>
              </tr>
              </template>
            </tbody>
        </table>
    </div>    
    <ErrorModal :swapid="swapid" modalid="ERRMODAL01">
        <p>ERROR MESSAGE THIS {{errormsg}}</p> 
    </ErrorModal>
    <ShowModal  ref="MODALX01" modalid="MODALX01" :swapid="swapid" 
                    :script="script">
          <div style='margin:auto;width:75%;font-size:10pt'>
            <br>
            <button v-if="currentdir == ''" style='padding:2px' 
              type="button" data-bs-dismiss="modal" 
              @click="execscript()">Exec</button>

            <button v-if="currentdir == '' || currentdir == '/.out'" 
              style='padding:2px;margin-left:10px' type="button" 
              data-bs-dismiss="modal" 
              @click="execview()">View</button>
            <button style='padding:2px;margin-left:10px' 
              type="button" data-bs-dismiss="modal" 
              @click="execrm()">Remove</button>
          </div>
    </ShowModal>
</template>

<style scoped>
.divstyle {
    font-size : 10pt ;
    max-height: 270px;
    overflow-y: auto;
    margin-top: 0px ;
}
.font-custom {
    font-size : 10pt ;
    text-align: left ;
}
.thx {
   height : 12px ;
   padding : 0 ;
}

.myheadline {
    height: 14pt ;
    background : #5090FF ;
    padding : 0px;
    margin : 0px;
}

.tralign {
  height: 12px ;
  text-algin: left ;
}

.leftalign {
    float: left ;
}
tbody tr:hover {
  background-color: yellow;
  cursor: pointer ;
}

.colpad {
  padding: 2px !important ;
  font-size: 10pt ;
  text-align : left ;
  white-space: nowrap ;
  overflow : auto ;
}
.headline {
  background : #8080FF;
  color : white ;
}
</style>

<script>
import axios from 'axios'
import ErrorModal from './ErrorModal.vue'
import ShowModal from './ShowModal.vue'
import bootstrap from 'bootstrap/dist/js/bootstrap.js'
import SwapMenu2 from './SwapMenu2.vue' 

export default {
  name: 'SwapExec',
  components: {
     ErrorModal, SwapMenu2, ShowModal 
  },
  props: {
    swapid : String
  },
  data() {
    return {
        file : '',
        selected : 'DIR FILE',
        currentdir: '', 
        dirlist : [ [ ".", "none", "none", "none" ] ],
        script : "",
        errormsg : "Invalid Command" 
    }
  },
  computed : {
    filterlist() {
        if (this.dirlist.length <= 0)
           return [ [ ".", "none", "none", "none" ] ] ;
        return this.dirlist ;
    }
  },
  mounted() {
    this.getdirlist("") ;
  },
  methods : {
    submitFile(){
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                  "/prosw/exec/upload?swapid=" + this.swapid +
                  "&filename=" + this.file.name  ;
        }
        catch(err) {
           console.log(err) ;
           return ;
        }

        /* Initialize the form data */
        let formData = new FormData();

        /* Add the form data we need to submit */
        formData.append('file', this.file);

        /* Make the request to the POST /single-file URL */
        axios.post( req,
            formData, 
            {
                headers: {
                   'Content-Type': 'multipart/form-data',
                   'Pswtoken': this.$store.getters.pswtoken 
                }
            }
          ).then(response => {
            let res = response.data ;
            if (typeof res == "object") 
                if (res.RESULT)
                    this.$parent.writeiframe (res.RESULT)
                else
                    this.$parent.writeiframe (JSON.stringify(res))
            else 
                this.$parent.writeiframe (response.data);
          })
          .catch(error =>
             { this.$parent.writeiframe ("ERROR :" + error) ; }
          );
    },
    handleFileUpload( event ){
        this.file = event.target.files[0];
    },
    refresh() {    // toggle start or stop swap
        this.getdirlist(this.currentdir);
    },
    getdirlist(newdir) {
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                  "/prosw/exec/view" + newdir + "?swapid=" + this.swapid ;
        }
        catch(err) {
           console.log(err) ;
           return ;
        }
        axios.get (req, {
            timeout: 5000,
            headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
           let myarray = [] ;

           if (newdir != "")  
               myarray.push ([ "..parent", "DIR", "0", "----------"])

           if (typeof response.data != "object") { 
               myarray.push ( [ "NOT JSON", "DIR", "ERROR", response.data.substr(0,15) ]) ;
               this.dirlist = myarray ;
               this.currentdir = this.currentdir + "/error" ;
               return ;
           }
           if (response.data.RC != "00") {
               myarray.push ( [ "RC :" + response.data.RC , "DIR", "ERROR", 
                                response.data.RDESC.substr(0,15) ]) ;
               this.dirlist = myarray ;
               this.currentdir = this.currentdir + "/error" ;
               return ;
           }

           let dirarr = response.data.RESULT ;
           for (let i in dirarr) {
             let dirobj = dirarr[i] ;
             let typex = dirobj.mode ;
             if (dirobj.mode == "40") 
                 typex = "DIR" ;
             else if (dirobj.mode == "100") 
                 typex = "FILE" ;
             else if (dirobj.mode == "104") 
                 typex = "FILE" ;
             myarray.push ([ dirobj.name,typex,dirobj.size,dirobj.mtime]) ;
           }
           this.dirlist = myarray ;
           this.currentdir = newdir ;
        }).catch ( (error) => { console.log(error) })
    },
    getAbsPosition(el) {
        let el2 = el;
        let curtop = 0;
        let curleft = 0;
        if (document.getElementById || document.all) {
            do  {
                curleft += el.offsetLeft-el.scrollLeft;
                curtop += el.offsetTop-el.scrollTop;
                el = el.offsetParent;
                el2 = el2.parentNode;
                while (el2 != el) {
                    curleft -= el2.scrollLeft;
                    curtop -= el2.scrollTop;
                    el2 = el2.parentNode;
                }
            } while (el.offsetParent);
        } else if (document.layers) {
            curtop += el.y;
            curleft += el.x;
        }
        return { 'top' : curtop, 'left' :  curleft } ;
    },
    showerror(errormsg, modalX, modalY) {
        let modalid = 'ERRMODAL01' ;
        let divmodal = document.getElementById( modalid ) ;
        this.errormsg = errormsg;
        let myModal = new bootstrap.Modal(divmodal, { backdrop : false }) ;
        divmodal.style.top =  (modalY - 50) + 'px' ;
        divmodal.style.left = modalX + 20 + 'px' ;
        myModal.show() ;
        return 0 ;
    },
    showmodal(script, modalX, modalY) {
        let modalid = 'MODALX01' ;
        let divmodal = document.getElementById( modalid ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;
        if (modalY > 550)
          divmodal.style.top =  '500px' ;
        else
          divmodal.style.top =  (modalY - 50) + 'px' ;
        divmodal.style.left = modalX + 20 + 'px' ;
        myModal.show() ;
        return 0 ;
    },
    changedir (data, posX, posY) 
    {
        if (data[1] != "DIR") 
            return this.showerror("Data DIR can not cd", posX, posY) ; 

        let newdir = "" ;
        if (data[0] == "..parent") {
           let a = this.currentdir.lastIndexOf("/"); 
           if (a <= 0)
                    newdir = "" ;
           else {
                    newdir = this.currentdir.substring(0,a) ;
                    if (newdir == "/") newdir = "" ;
           }
       }
       else 
           newdir = this.currentdir + "/" + data[0] ;        
       this.getdirlist(newdir) ;
    },
    execview() {
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                "/prosw/exec/view?filename=" + this.currentdir + "/" +
                    this.script + "&swapid=" + this.swapid  ;
        }
        catch(err) {
            console.log(err) ;
            return ;
        }
        this.sendreq(req) ;
    },
    execscript() {
        this.$parent.writeiframe ("Please Wait Excecuting " + this.script + " ...") ;
        let req = "" ;
        try {
            req = this.$store.getters.controller_url +
                "/prosw/exec/x/" + this.script + "?" + "swapid=" + 
                this.swapid + "&argument=" + this.$refs.MODALX01.argument ;
        }
        catch(err) {
            console.log(err) ;
            return ;
        }
        this.sendreq(req) ;
    },
    execrm() {
        let req = "" ;
        if (! confirm("Remove File ?")) return ;
        try {
            req = this.$store.getters.controller_url +
                "/prosw/exec/rm/" + this.currentdir + "/" + this.script + 
                    "?swapid=" + this.swapid  ;
        }
        catch(err) {
            console.log(err) ;
            return ;
        }
        this.sendreq(req, 1) ;
    },
    sendreq(req, ref = 0) {    
        axios.get (req,  {
           timeout: 15000,
           responseType: 'text', 
           headers: {'Pswtoken': this.$store.getters.pswtoken }
        }).then ( (response) => {
            let res = response.data ;
            if (typeof res == "object") {
                this.$parent.writeiframe (JSON.stringify(res))
            }
            else {
                this.$parent.writeiframe (response.data);
            }
            if (ref) this.refresh();
       }).catch ( (error) => { 
            this.$parent.filepath = '';
            this.$parent.writeiframe ("REQUEST TIMEMOUT") ;
            if (error.code === 'ECONNABORTED') {
                console.log('Request timed out');
            } else {
                console.log(error.message);
          }
       })
    },
    doaction(event, rowkey)
    {
        let rowdata = this.dirlist.find ( x => x[0] == rowkey) ;
        if (! rowdata) 
            return this.showerror( "Data not found", event.clientX, event.clientY) ; 
        if (rowdata[1] == "DIR") 
            this.changedir(rowdata, event.clientX, event.clientY)  ;
        else if (rowdata[1] == "FILE") {
            if (rowdata[1] != "FILE") 
                return this.showerror ("Data not file", event.clientX, event.clientY) ; 
            if (this.currentdir == "" && parseInt(rowdata[2]) > 16 * 1024) 
                return this.showerror ("This Does not look like a script file", 
                    event.clientX, event.clientY) ; 
            this.script = rowdata[0] ;
            this.$parent.filepath = '' ;    // for saving file 
            this.showmodal(rowdata[0], event.clientX, event.clientY) ;
        }
        else
            return this.showerror( "Command Not Supported :" + this.selected, 
                        event.clientX, event.clientY) ; 
    }
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>


